import { render, staticRenderFns } from "./DocViewPopUp.vue?vue&type=template&id=0b382502&scoped=true"
import script from "./DocViewPopUp.vue?vue&type=script&lang=js"
export * from "./DocViewPopUp.vue?vue&type=script&lang=js"
import style0 from "./DocViewPopUp.vue?vue&type=style&index=0&id=0b382502&prod&scoped=true&lang=css"
import style1 from "./DocViewPopUp.vue?vue&type=style&index=1&id=0b382502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b382502",
  null
  
)

export default component.exports